import { object } from 'zod';

import { LimitSchema, validateMembershipLessThanGlobal } from '@occc/feat-limits';

export const SweepstakesAwardCountSchema = object({
  membership: LimitSchema,
  global: LimitSchema,
}).superRefine((data, ctx) => {
  validateMembershipLessThanGlobal({ membership: data.membership, global: data.global, ctx });
});
